<template>
  <v-container id="listadosmatriculados-caplp">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  dark
                  color="success"
                  class="alineacentro DatosMatriculado"
                >
                  <strong>LISTADOS DE MATRICULADOS</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-spacer />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="alineaizquierda">
                <v-select
                  v-model="idreportesel"
                  :items="listareportes"
                  label="Reporte"
                  item-text="nombre"
                  item-value="idreporte"
                  height="20px"
                  class="ocupa50"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="alineaizquierda">
                <v-select
                  v-model="formatosel"
                  :items="listaformatos"
                  label="Formato"
                  item-text="formato"
                  item-value="formato"
                  height="20px"
                  class="ocupa50"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                <v-menu
                  v-model="menufecreporte"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfechareporte"
                      label="Fecha Reporte"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechareporte"
                    @input="menufecreporte = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="10" lg="10" class="alineaizquierda">
                <v-btn color="green darken-1" text @click="ExportaReporte" :disabled="!permisolectura">
                  Exportar
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="idreportesel===1 || idreportesel===2">
              <v-col cols="12" class="alineaizquierda">
                <v-menu
                  v-model="menufecinteres"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfechacalculo"
                      label="Fecha p/ Cálculo Deuda"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      class="ocupa10"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechacalculo"
                    @input="menufecinteres = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="loading" fullscreen full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "@/axios";
export default {
  name: "listadosmatriculados",
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 7,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      listaformatos: [{ formato: "PDF" }, { formato: "EXCEL" }],
      formatosel: 'PDF',
      idreportesel: 1,
      listareportes: [
        { idreporte: 1, nombre: "Matriculados en condiciones de ser elegidos" },
        { idreporte: 2, nombre: "Matriculados en condición de votar" },
        { idreporte: 35, nombre: "Matriculados para Listado de Juez del Tribunal" }
      ],
      menufecinteres: false,
      fechacalculo: this.fechaFormatoVmenu(new Date()),
      menufecreporte: false,
      fechareporte: this.fechaFormatoVmenu(new Date()),
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var idrol = localStorage.getItem("rolusuario");
    var roles= localStorage.getItem('rolesusuario')
    var existeper=permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario)  && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error", "No tiene permisos para acceder a este módulo.", true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.loading = false;
    }
  },
  methods: {
    ExportaReporte() {
      if (this.idreportesel !== null && this.idreportesel !== "") {
        if (this.formatosel !== null && this.formatosel !== "") {
          this.loading = true;
          var listap=[];
          if(this.idreportesel===1 || this.idreportesel===2) {
            listap= [{ orden: 1, nombre: "subtituloreporte", valor: "" },{ orden: 2, nombre: "fechacalculo", valor: this.fechacalculo },{ orden: 3, nombre: "fechareporte", valor: this.funfechalocalfechareporte() }];
          }else if(this.idreportesel===35) {
            listap= [{ orden: 1, nombre: "fechacorte", valor: this.fechareporte.toString() }];
          }
          axios.post("reportes/GetReporte",{ idreporte: this.idreportesel, formato: this.formatosel, listaparametros: listap,},{ headers: {"Content-Type": "application/json",}}).then((result) => {
            this.loading = false;
            if (result.data.toString().startsWith("Error") === false) {
              window.open(result.data, "_blank");
            } else {
              this.MostrarMensaje("Error", result.data, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        } else {
          this.MostrarMensaje("Error", "Debe seleccionar el formato!!!", false);
        }
      } else {
        this.MostrarMensaje("Error", "Debe seleccionar un reporte!!!", false);
      }
    },
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    fechaFormatoVmenu(date) {
      return (
        date.getFullYear() +
        "-" +
        ((date.getMonth() + 1).toString().length != 2
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "-" +
        (date.getDate().toString().length != 2
          ? "0" + date.getDate()
          : date.getDate())
      );
    },
    funfechalocalfechareporte: function () {
      if (this.fechareporte != null && this.fechareporte != "") {
        var fecha = new Date(this.fechareporte);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
  computed: {
    fechalocalfechacalculo: function () {
      if (this.fechacalculo != null && this.fechacalculo != "") {
        var fecha = new Date(this.fechacalculo);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfechareporte: function () {
      if (this.fechareporte != null && this.fechareporte != "") {
        var fecha = new Date(this.fechareporte);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
</style>
